import React from "react";
import PT from "prop-types";
import * as S from "./meta-styled";
import { generateAvatar } from "@/utils";
import { Link } from "react-router-dom";
import moment from "moment";
import MetaCounter from "_c/MetaCounter";
import ShareIcon from "_c/icon/Share";
import StarIcon from "_c/icon/Star";
import CommentIcon from "_c/icon/Comment";
import { LinkGenerator } from "@/utils/LinkGenerator";
import qs from "query-string";

const ArticleMeta = (props) => {
  const authorLink = props.author.master
    ? LinkGenerator.masterProfile(props.author.master)
    : LinkGenerator.clientProfile(props.author._id);
  const onLike = () => (props.isAuth ? props.toggleLike(props.id) : null);
  return (
    <S.Wrap>
      <S.Top>
        <Link
          to={qs.stringifyUrl({
            url: authorLink,
            query: { hl: props.hl },
          })}
        >
          <S.Author>
            <img
              src={generateAvatar({
                url: props.author.avatar,
                sex: props.author.sex,
              })}
            />
            <span>
              {[props.author.first_name, props.author.last_name]
                .filter(Boolean)
                .join(" ")}
            </span>
          </S.Author>
        </Link>
        <S.Timestamp>{moment(props.created).calendar()}</S.Timestamp>
      </S.Top>
      <S.Counters>
        <S.CommentsMeta count={props.comments}>
          <CommentIcon color="var(--color-primary)" />
        </S.CommentsMeta>
        <MetaCounter onClick={onLike} count={props.likes}>
          <StarIcon filled={props.isFavorite} color="var(--color-primary)" />
        </MetaCounter>
        <MetaCounter onClick={props.openShareModal}>
          <ShareIcon color="var(--color-primary)" />
        </MetaCounter>
      </S.Counters>
    </S.Wrap>
  );
};

ArticleMeta.propTypes = {
  author: PT.object,
  created: PT.string,
  comments: PT.number,
  likes: PT.number,
  id: PT.string,
  isAuth: PT.bool,

  openShareModal: PT.func,
  toggleLike: PT.func.isRequired,
  isFavorite: PT.bool.isRequired,
};

export default ArticleMeta;
